<template>
  <div class="tab-temp">
    <div class="title">支付信息</div>
    <div class="tab-temp-wrap">
      <div class="tab-temp-date">
        <div class="long-name total">应付金额</div>
        <div class="long-name-val total">￥{{(order.pay_amount / 100) || 0}}</div>
      </div>

      <div class="tab-temp-id">
        <div class="long-name">商品金额</div>
        <div class="long-name-val">￥{{getTotalProductAmount(order)}}</div>
      </div>

      <div class="tab-temp-sf" v-for="(express, index) in realSFOrder" :key="index">
        <div class="long-name">顺丰<span v-text="express.tracking_number"></span></div>
        <div class="long-name-val">￥{{ express.pickup_amount / 100}}</div>
      </div>

      <div class="tab-temp-id" v-if="order.return_express_amount">
        <div class="long-name">顺丰回寄运费</div>
        <div class="long-name-val">￥{{order.return_express_amount / 100}}</div>
      </div>

      <template v-if="order.order_insurance && order.order_insurance.insurance_type === 1">
        <!-- 自选保险前置购买 -->
        <div class="tab-temp-id" v-if="order.order_insurance.insurance_pay_record.length == 0">
          <div class="long-name">旅游保险</div>
          <div class="long-name-val">￥{{order.order_insurance.single_pay_amount * order.applicant.length / 100}}（¥{{order.order_insurance.single_pay_amount / 100}}×{{order.applicant.length}}）</div>
        </div>
        <template v-if="order.order_insurance.insurance_pay_record.length">
          <!-- 自选保险后置购买 -->
          <div class="tab-temp-id" v-for="(item, index) in order.order_insurance.insurance_pay_record" :key="index + 'buy'">
            <div class="long-name">旅游保险</div>
            <div class="long-name-val">¥{{item.pay_amount / 100}}</div>
          </div>
        </template>
        <template v-if="order.order_insurance.insurance_change_pay_record.length">
          <!-- 修改保期 -->
          <div class="tab-temp-id" v-for="(item, index) in order.order_insurance.insurance_change_pay_record" :key="index">
            <div class="long-name">修改保期</div>
            <div class="long-name-val">¥{{item.pay_amount / 100}}（¥{{item.pay_amount / item.applicants / 100}}×{{item.applicants}}）</div>
          </div>
        </template>
      </template>

      <div class="tab-temp-id" v-if="order.order_insurance && (order.order_insurance.insurance_type === 2 || order.order_insurance.insurance_type === 3)">
        <div class="long-name">旅游保险</div>
        <div class="long-name-val">￥{{order.order_insurance.single_pay_amount / 100 * order.applicant.length}}</div>
      </div>

      <div class="tab-temp-date" v-for="diff in order.paid_price_diff" :key="diff.id" v-if="order.paid_price_diff && order.paid_price_diff.length">
        <div class="long-name">{{diff.item}}</div>
        <div class="long-name-val">￥{{diff.diff_fee / 100}}</div>
      </div>

      <div class="tab-temp-id" v-if="order.vip_amount">
        <div class="long-name">V{{order.vip_level}}会员优惠</div>
        <div class="long-name-val">- ￥{{order.vip_amount / 100}}</div>
      </div>

      <div class="tab-temp-id" v-if="order.coupon_amount">
        <div class="long-name">优惠券</div>
        <div class="long-name-val">-￥{{order.coupon_amount / 100}}</div>
      </div>

      <template v-if="order.interview_change_pay_record">
        <div class="tab-temp-id" v-for="(item, index) in order.interview_change_pay_record" :key="index">
          <div class="long-name">修改赴馆时间</div>
          <div class="long-name-val">￥{{item.interview_change_amount / 100}}(￥{{`${item.interview_change_fee / 100}×${item.applicant_id_set.length}`}})</div>
        </div>
      </template>

      <div class="tab-temp-id" v-if="order.reduction_amount">
        <div class="long-name">小程序立减</div>
        <div class="long-name-val">-￥{{order.reduction_amount / 100}}</div>
      </div>

      <div class="tab-temp-id reject-product" v-if="order.reject_product_set && order.reject_product_set.reject_product_id">
        <div class="long-name">拒签服务</div>
        <div class="long-name-val">￥{{ (order.reject_product_amount || 0) / 100}}</div>
      </div>

    </div>

    <div class="tab-temp-wrap border-top" v-if="order.unpaid_price_diff">
      <div class="tab-temp-date">
        <div class="long-name total">补缴费用</div>
        <div class="long-name-val total">￥{{order.unpaid_price_diff.diff_fee / 100}}</div>
      </div>

      <div class="tab-temp-date" v-if="order.unpaid_price_diff">
        <div class="long-name">{{order.unpaid_price_diff.item}}</div>
        <div class="long-name-val">￥{{order.unpaid_price_diff.diff_fee / 100}}</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'orderPayAmount',
  props: {
    order: {
      type: Object,
      default() {
        return {};
      },
    },
    peer: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    /**
     * 获取应付商品金额总价
     * @param {Object} order 订单信息
     * @return {Number} 订单支付金额
     */
    getTotalProductAmount(order) {
      if (!order) return 0;

      let allProductAmount = 0;

      if (order.applicant && order.applicant.length > 0) {
        order.applicant.forEach((applicant) => {
          allProductAmount += applicant.sell_price;
        });
      }

      return allProductAmount / 100;
    },

    // 获取总的补缴费用
    getDiffPrice(diffs, unpaidDiff) {
      const paid = diffs
        ? diffs.reduce((a, b) => a.diff_fee + b.diff_fee, { diff_fee: 0 }) / 100
        : 0;
      const unpaid = unpaidDiff ? unpaidDiff.diff_fee / 100 : 0;
      return paid + unpaid;
    },
  },
  computed: {
    /**
     * 获取正真的顺丰订单
     */
    realSFOrder() {
      if (
        !this.order.order_pickup ||
        (this.order.order_pickup && this.order.order_pickup.length === 0)
      ) {
        return [];
      }

      return this.order.order_pickup.filter(item =>
        Boolean(item.tracking_number),
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.tab-temp {
  background-color: #fff;
  padding-bottom: 1px;
  .title {
    padding: 18px 20px 2px 20px;
    font-weight: 600;
    font-size: 16px;
    margin-top: 15px;
  }

  .tab-temp-wrap {
    font-size: 14px;
    background-color: #fff;
    margin: 0 40px 0 40px;
    & > div {
      margin: 16px 0;
      color: #333;
      overflow: hidden;
      .long-name {
        width: 100px;
        color: #777;
        float: left;
      }
      .long-name-val {
        color: #777;
        margin-left: 100px;
        white-space: pre-wrap;
      }
      .name {
        width: 100px;
        color: #777;
        float: left;
      }
      .value {
        margin-left: 100px;
        white-space: pre-wrap;
      }
      .commens {
        line-height: 18px;
      }
      .long-name.total {
        font-weight: bold;
        color: #333;
      }
      .long-name-val.total {
        font-size: 14px;
        font-weight: bold;
      }
      &.reject-product {
        padding-top: 20px;
        border-top: 1px dotted #E9EEF2; 
      }
    }
    &.border-bottom {
      border-bottom: 1px solid #f0f0f0;
    }
    &.border-top {
      border-top: 1px solid #f0f0f0;
    }
  }

  .node {
    color: #777;
    font-size: 12px;
    margin-left: 10px;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-detail/order-pay-amount.vue